export default {
  people: {
    title: 'Conectamos Pessoas e Tecnologias!',
    description:
      'Sabemos que as pessoas são o nosso maior bem. Por isso, cuidamos, acolhemos, formamos e desenvolvemos nosso #timeSIS, por meio de recursos educacionais, tecnológicos, comportamentais e programas de saúde e bem-estar. Dessa forma, garantimos entregas alinhadas as expectativas e que geram valor real para os clientes e para os nossos colaboradores.',
  },
}
